import { render, staticRenderFns } from "./ADassistant.vue?vue&type=template&id=493f7605&scoped=true"
import script from "./ADassistant.vue?vue&type=script&lang=js"
export * from "./ADassistant.vue?vue&type=script&lang=js"
import style0 from "./ADassistant.vue?vue&type=style&index=0&id=493f7605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f7605",
  null
  
)

export default component.exports